export const baseTypography = {
    font: {
        family: {
            serif: 'Figs, Raleway, sans-serif',
            sanSerif: 'Figs, Raleway, sans-serif',
        },
        weight: {
            '400': '400',
            '500': '500',
            '600': '600',
            '700': '700',
            '900': '900',
        },
        size: {
            '9': '9px',
            '11': '11px',
            '12': '12px',
            '13': '13px',
            '14': '14px',
            '16': '16px',
            '17': '17px',
            '18': '18px',
            '20': '20px',
            '22': '22px',
            '25': '25px',
            '28': '28px',
            '36': '36px',
            '44': '44px',
            '56': '56px',
        },
        letterSpacing: {
            medium: '0.05em',
            wide: '0.15em',
        },
        lineHeight: {
            tight: '1.25',
            medium: '1.4',
            loose: '1.5',
            looser: '1.7',
        },
    },
};
//# sourceMappingURL=baseTypography.js.map